import { useContext } from 'react';

import { ReportDataContext } from '@/contexts/ReportDataProvider';

export const useReportData = () => {
  return useContext(ReportDataContext);
};
